












import { Vue, Component, Prop, Inject, InjectReactive } from "vue-property-decorator";
import widgets from "../package/widgets";
import wgetMgr from "../package/widgets/wgetMgr";

@Component({
  name: "MagicBlock",
  components: { ...widgets }
})
export default class MagicBlock extends Vue {
  @Prop({
    type: String,
    required: true
  })
  private blockId!: string;

  @Inject()
  private model!: any;

  @InjectReactive("htmlOptions")
  private htmlOptions!: {
    options: { template: string; widgets: App.WebForm.Widget[] };
    model: any;
  };

  get widget() {
    const widget = this.htmlOptions.options.widgets.find((d) => d.id === this.blockId);
    if (!widget) return null;
    return widget;
  }

  get style() {
    const style: any = {};
    if (this.widget?.readonly) {
      style.width = "auto";
      style.minWidth = "0px";
      return {
        width: "auto",
        minWidth: "0",
        minHeight: "auto",
        verticalAlign: "auto",
        margin: 0,
        padding: 0
      };
    } else if (this.widget?.isCustomBlockWidth) {
      style.width = (this.widget.blockWidth || 0) + "px";
      style.minWidth = "20px";
    }
    return style;
  }

  mounted() {
    if (this.widget && this.widget?.id !== "-1") {
      wgetMgr.setWidgetById(this.widget.id, this.$refs[this.widget.id]);
    }
  }
}
